function getTitle (vm) {
  // title can be set in each view
  const { title } = vm.$options;
  if (title) {
    return typeof title === 'function'
      ? title.call(vm)
      : title
  }
}

export default {
  mounted () {
    const title = getTitle(this);
    if (title) {
      // <title> in <head>
      document.title = `${title} | Debye Leong`;
    }
    // NOTE: this will be invoked even in partial page component reload
  }
}
